import React, {Component} from 'react';
import Button from '../../global/button/button';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import logger from '../../global/logger';

class MediaUploadButton extends Component {

    uploadMedia() {
        logger.log("uploadMedia");
        // this.props.onUploadMedia();
        this.refs.upload.click();
    }

    readFile(event) {
        logger.log("readFile");

        for (let i = 0; i < event.target.files.length; i++) {
            this.props.onUploadMedia(event.target.files[i], this.props.playlist_id, () => {
                this.props.onFetchMedia();
            });
        }
    }

    render() {
        return (
            <div>
                <Button id={this.props.id} className={"float-right mx-2" + this.props.className} text={this.props.text} icon={ArrowUpTrayIcon} clickEvent={() => this.uploadMedia()} />
                <div className="hidden">
                    <input id="upload" ref="upload" type="file" accept="image/*" multiple
                        onChange={(event)=> { 
                            this.readFile(event) 
                        }}
                        onClick={(event)=> { 
                            event.target.value = null
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default MediaUploadButton;